// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"f2ae91fa","447":"fb8b48a6"}[chunkId] + ".chunk.css";
};